import BaseStore from '@/store/baseStore'
import { set } from 'lodash'
import generateBaseImportFromStage from '@/store/baseImportFromStage'
import api from '../api/api'

export const namespaced = true

const baseUrl = '/reinforcement_input/'
const baseStore = new BaseStore(baseUrl)
const baseImportFromStage = generateBaseImportFromStage({})

const getDefaultState = () => ({
  ...structuredClone(baseStore.state),
  ...structuredClone(baseImportFromStage.state),
  overToppingRateOption: [],
  continueOuterSlopeChoices: [
    { value: true, title: 'Yes' },
    { value: false, title: 'No' }
  ],
  generateLoading: false,
  writeLoading: false,
  fetchingCrestLevelAndSettlement: false
})

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ...baseImportFromStage.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  SET_ITEM_BY_PATH(state, { value, item, parameter }) {
    set(item, parameter, value)
  },
  SET_OVERTOPPING_RATE_OPTIONS(state, options) {
    state.overToppingRateOption = options
  },
  TOGGLE_GENERATE_LOADING(state) {
    state.generateLoading = !state.generateLoading
  },
  TOGGLE_FETCHING_CREST_LEVEL_AND_SETTLEMENT(state) {
    state.fetchingCrestLevelAndSettlement = !state.fetchingCrestLevelAndSettlement
  }
}

export const actions = {
  ...baseStore.actions,
  ...baseImportFromStage.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  },
  setNestedParameter(context, payload) {
    context.commit('SET_ITEM_BY_PATH', payload)
    context.commit('ADD_DIRTY_ITEM', payload.item)
  },
  async fetchCrestLevelOvertoppingRates(context) {
    const query = new URLSearchParams({
      search: context.rootState.project.currentProject.id
    }).toString()
    const url = `/crest_level_boundary_conditions/overtopping_rate_options/?${query}`
    const response = await api.get(url)
    context.commit('SET_OVERTOPPING_RATE_OPTIONS', response.data)
  },
  async updateGenerateOption({ state, commit }) {
    await api.patch(`${baseUrl}${state.currentItem.id}/`, state.currentItem)
    commit('EMPTY_DIRTY_ITEM')
  },
  async fetchCrestLevelAndSettlement({ state }) {
    const query = new URLSearchParams({
      year_id: state.currentItem.dike_reinforcement_input.year,
      slope: state.currentItem.dike_reinforcement_input.selected_slope,
      overtopping_rate: state.currentItem.dike_reinforcement_input.overtopping_rate
    }).toString()
    const url = `${baseUrl}${state.currentItem.id}/get_crest_level_and_settlement?${query}`
    const response = await api.get(url)
    return response.data
  },
  async importReinforcementGenerateOptionFromStage(
    { commit, dispatch },
    { sourceSchematisationStageId, targetSchematisationStageId }
  ) {
    try {
      commit('TOGGLE_IMPORT_FROM_STAGE_LOADING')
      const importedReinforcementGenerateOption = await dispatch('importFromStage', {
        import_option: {
          source_stab_schematisation_stage_id: sourceSchematisationStageId,
          target_stab_schematisation_stage_id: targetSchematisationStageId
        },
        stab_schematisation_stage: targetSchematisationStageId
      })
      commit('SET_CURRENT_ITEM', importedReinforcementGenerateOption)
    } catch (e) {
      console.log(e)
    } finally {
      commit('TOGGLE_IMPORT_FROM_STAGE_LOADING')
    }
  },
  async generateReinforcement({ commit }, stabSchematisationStageId) {
    try {
      commit('TOGGLE_GENERATE_LOADING')
      const url = `${baseUrl}${stabSchematisationStageId}/generate_reinforcements/`
      const response = await api.post(url, { stab_schematisation_stage: stabSchematisationStageId })
      const { reinforcements, reinforcement_points } = response.data
      commit('reinforcement/ADD_ITEMS', reinforcements, { root: true })
      commit('reinforcementPoint/ADD_ITEMS', reinforcement_points, { root: true })
    } catch (e) {
      console.log(e)
    } finally {
      commit('TOGGLE_GENERATE_LOADING')
    }
  },
  toggleFetchingCrestLevelAndSettlement({ commit }) {
    commit('TOGGLE_FETCHING_CREST_LEVEL_AND_SETTLEMENT')
  }
}

export const getters = {
  getSlopeChoices(state) {
    return state.options?.dike_reinforcement_input.children.selected_slope.choices
  },
  getStartingPointChoices(state) {
    return state.options?.dike_reinforcement_input.children.starting_point.choices
  }
}
